import { Instance, types as t } from 'mobx-state-tree';

export const Statistics = t.model('Statistics', {
  ongoing_auctions: t.number,
  start_bid_total: t.number,
  winning_bid_total: t.number,
});

export type StatisticsInstance = Instance<typeof Statistics>;
